import type { ReactNode } from 'react';
import { MODULE_KEYS } from '@hr-outsourcing/shared';
import { ModuleGate } from '@/components/ModuleGate';
import { useAuth } from '@/hooks/useAuth';
import { isListingOnlyUser } from '@/lib/accountType';

/**
 * The settings page behind its module — except for a listing-only company, whose package has no
 * settings module: it opens the page for its company details alone.
 */
export const SettingsRoute = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();
  if (isListingOnlyUser(user)) return <>{children}</>;
  return <ModuleGate moduleKey={MODULE_KEYS.SETTINGS}>{children}</ModuleGate>;
};
